import { Button } from "./Button";
import { ErrorIcon } from "./ErrorIcon";
import styles from "./ErrorState.module.css";

interface ErrorStateProps {
  /** Body-sized, centered message describing what went wrong. Keep it
   *  in Big Wind's voice (see docs/content-guidelines.md). */
  message: string;
  /** Label for the action button. Defaults to "Retry". */
  actionLabel?: string;
  /** Click handler for the action button. The button only renders when
   *  this is provided — terminal states (e.g. genuinely missing data)
   *  can omit it and show just the mark + message. */
  onAction?: () => void;
  className?: string | undefined;
}

/**
 * Shared error / dead-end state — Figma node 359:17307 (Error
 * component). Centered column: Big Wind error mark, a message, and an
 * optional action button (Retry, or e.g. "Back to spots" for not-found
 * cases). Fills the content area it's dropped into.
 */
export function ErrorState({
  message,
  actionLabel = "Retry",
  onAction,
  className,
}: ErrorStateProps) {
  return (
    <div className={[styles.errorState, className].filter(Boolean).join(" ")} role="alert">
      <div className={styles.text}>
        <ErrorIcon className={styles.icon} />
        <p className={styles.message}>{message}</p>
      </div>
      {onAction && (
        <Button variant="default" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
